import { ACCOUNT_ERROR, LOADING_ACCOUNT, SET_ACCOUNT, SET_ACCOUNT_STATUS } from "../constants";

const initial_state = {
  loading: false,
  status: null,
  error: null,
  number: "",
  parent_account: "",
  user_account: "",
  account_variables: [],
};

interface stateOptions {
  type: string;
  payload?: any;
}

export default function Account(state = initial_state, { type, payload }: stateOptions) {
  switch (type) {
    case ACCOUNT_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case LOADING_ACCOUNT:
      return {
        ...state,
        loading: true,
      };

    case SET_ACCOUNT:
      return {
        ...state,
        loading: false,
        number: payload.id,
        parent_account: payload.parent_account,
        account_variables: payload.variables,
      };

    case SET_ACCOUNT_STATUS:
      return {
        ...state,
        status: payload.status
      }

    default:
      return state;
  }
}
